<div class="cfg-page">

  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title"><i class="fal fa-file-search"></i> Demandes de Devis</h1>
      <p class="page-header__sub">Demandes de tarification soumises par les clients — {{ demandes.length }} demande(s)</p>
    </div>
    <div class="header-actions">
      <button class="btn-refresh" (click)="charger()" [disabled]="chargement">
        <i class="fal fa-sync" [class.fa-spin]="chargement"></i> Actualiser
      </button>
    </div>
  </div>

  <!-- KPIs -->
  <div class="kpi-row">
    <div class="kpi-card"><span class="kpi-val">{{ demandes.length }}</span><span class="kpi-label">Total</span></div>
    <div class="kpi-card kpi-card--orange"><span class="kpi-val">{{ enAttente }}</span><span class="kpi-label">En attente</span></div>
    <div class="kpi-card kpi-card--blue"><span class="kpi-val">{{ enCours }}</span><span class="kpi-label">En cours</span></div>
    <div class="kpi-card kpi-card--green"><span class="kpi-val">{{ acceptees }}</span><span class="kpi-label">Acceptées</span></div>
  </div>

  <!-- Filtres -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltres()" placeholder="Ville, client, email…" />
    </div>
    <select class="filtre-select" [(ngModel)]="filtreStatut" (ngModelChange)="appliquerFiltres()">
      <option value="">Tous les statuts</option>
      <option *ngFor="let s of statutsListe" [value]="s">{{ libelleStatut(s) }}</option>
    </select>
  </div>

  <!-- Chargement -->
  <div class="etat-centre" *ngIf="chargement"><div class="spinner"></div><span>Chargement…</span></div>

  <!-- Vide -->
  <div class="etat-centre" *ngIf="!chargement && demandesFiltrees.length === 0">
    <i class="fal fa-file-search" style="font-size:36px;color:#cbd5e0"></i>
    <p>Aucune demande de devis trouvée.</p>
  </div>

  <!-- Tableau -->
  <div class="table-wrapper" *ngIf="!chargement && demandesFiltrees.length > 0">
    <table class="data-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Client</th>
          <th>Trajet</th>
          <th>Date demande</th>
          <th>Articles</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of demandesFiltrees">
          <td><strong>#{{ d.id }}</strong></td>
          <td>
            <strong>{{ nomClient(d) }}</strong>
            <small *ngIf="d.user?.email" style="display:block;font-size:11px;color:#a0aec0">{{ d.user?.email }}</small>
            <small *ngIf="d.user?.telephone" style="display:block;font-size:11px;color:#a0aec0">{{ d.user?.telephone }}</small>
          </td>
          <td>
            <div class="trajet-inline">
              <span class="ville-badge ville-badge--dep"><i class="fal fa-map-marker-alt"></i> {{ d.villeDepart }}</span>
              <i class="fal fa-long-arrow-right" style="color:#cbd5e0"></i>
              <span class="ville-badge ville-badge--arr"><i class="fal fa-map-marker-alt"></i> {{ d.villeArrivee }}</span>
            </div>
          </td>
          <td>{{ d.dateEnvoi | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>
            <span class="nb-badge" *ngIf="d.articles?.length">{{ d.articles?.length }} art.</span>
            <span *ngIf="!d.articles?.length" style="color:#a0aec0">—</span>
          </td>
          <td>
            <span class="statut-badge" [ngClass]="badgeStatut(d.statut)">{{ libelleStatut(d.statut) }}</span>
          </td>
          <td>
            <div class="actions-cell">
              <button class="btn-action btn-action--blue" (click)="ouvrirDetail(d)" title="Voir le détail">
                <i class="fal fa-eye"></i>
              </button>
              <button class="btn-action btn-action--green" *ngIf="d.statut === 'EN_ATTENTE' || d.statut === 'EN_COURS'"
                      (click)="changerStatut(d, 'ACCEPTE')" [disabled]="enCoursStatut === d.id" title="Accepter">
                <i class="fal fa-check"></i>
              </button>
              <button class="btn-action btn-action--teal" *ngIf="d.statut === 'EN_ATTENTE'"
                      (click)="changerStatut(d, 'EN_COURS')" [disabled]="enCoursStatut === d.id" title="Mettre en cours">
                <i class="fal fa-play"></i>
              </button>
              <button class="btn-action btn-action--danger" *ngIf="d.statut !== 'REFUSE' && d.statut !== 'ACCEPTE'"
                      (click)="changerStatut(d, 'REFUSE')" [disabled]="enCoursStatut === d.id" title="Refuser">
                <i class="fal fa-times"></i>
              </button>
              <button class="btn-action btn-action--purple" *ngIf="d.statut === 'ACCEPTE'"
                      (click)="creerCommandeDepuisDevis(d)" title="Créer une commande depuis ce devis">
                <i class="fal fa-plus-circle"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- MODAL DETAIL -->
<div class="modal-backdrop" *ngIf="afficherDetail && demandeSelectionnee" (click)="fermerDetail()">
  <div class="modal-card modal-card--large" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-header__icon" style="background:#ede9fe;color:#7c3aed"><i class="fal fa-file-search"></i></div>
        <div>
          <h3>Demande de devis #{{ demandeSelectionnee.id }}</h3>
          <p class="modal-header__sub">
            <span class="statut-badge" [ngClass]="badgeStatut(demandeSelectionnee.statut)">{{ libelleStatut(demandeSelectionnee.statut) }}</span>
          </p>
        </div>
      </div>
      <button class="modal-close" (click)="fermerDetail()"><i class="fal fa-times"></i></button>
    </div>

    <div class="modal-body" style="padding:0">
      <!-- Trajet -->
      <div class="detail-section">
        <h4 class="detail-section__title"><i class="fal fa-route"></i> Trajet demandé</h4>
        <div class="trajet-banner-detail">
          <div class="trajet-banner-detail__zone">
            <i class="fal fa-map-marker-alt" style="color:#2563eb;font-size:18px"></i>
            <span style="font-weight:700;color:#1d4ed8;font-size:15px">{{ demandeSelectionnee.villeDepart }}</span>
            <small style="color:#9ca3af">Départ</small>
          </div>
          <div style="flex:1;height:2px;background:linear-gradient(to right,#dbeafe,#ccfbf1);border-radius:2px;margin:0 12px"></div>
          <div class="trajet-banner-detail__zone" style="text-align:right">
            <i class="fal fa-map-marker-alt" style="color:#00897B;font-size:18px"></i>
            <span style="font-weight:700;color:#00695c;font-size:15px">{{ demandeSelectionnee.villeArrivee }}</span>
            <small style="color:#9ca3af">Arrivée</small>
          </div>
        </div>
      </div>

      <!-- Client -->
      <div class="detail-section" *ngIf="demandeSelectionnee.user">
        <h4 class="detail-section__title"><i class="fal fa-user"></i> Informations client</h4>
        <div class="info-grid">
          <div class="info-field"><span class="info-label">Nom</span><span class="info-val">{{ nomClient(demandeSelectionnee) }}</span></div>
          <div class="info-field" *ngIf="demandeSelectionnee.user?.email"><span class="info-label">Email</span><span class="info-val">{{ demandeSelectionnee.user.email }}</span></div>
          <div class="info-field" *ngIf="demandeSelectionnee.user?.telephone"><span class="info-label">Téléphone</span><span class="info-val">{{ demandeSelectionnee.user.telephone }}</span></div>
        </div>
      </div>

      <!-- Articles -->
      <div class="detail-section" *ngIf="demandeSelectionnee.articles?.length">
        <h4 class="detail-section__title"><i class="fal fa-boxes"></i> Articles demandés <span class="detail-count">{{ demandeSelectionnee.articles?.length }}</span></h4>
        <table class="data-table" style="font-size:12.5px">
          <thead><tr><th>Description</th><th>Quantité</th><th>Poids (kg)</th><th>Volume (m³)</th></tr></thead>
          <tbody>
            <tr *ngFor="let a of demandeSelectionnee.articles">
              <td>{{ a.description ?? a.libelle ?? '—' }}</td>
              <td>{{ a.quantite ?? '—' }}</td>
              <td>{{ a.poids ?? '—' }}</td>
              <td>{{ a.volume ?? '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <ng-container *ngIf="['EN_ATTENTE','EN_COURS'].includes(demandeSelectionnee.statut)">
        <button class="btn-modal-danger" (click)="changerStatut(demandeSelectionnee, 'REFUSE')" [disabled]="enCoursStatut === demandeSelectionnee.id">
          <i class="fal fa-times"></i> Refuser
        </button>
        <button class="btn-modal-primary" (click)="changerStatut(demandeSelectionnee, 'ACCEPTE')" [disabled]="enCoursStatut === demandeSelectionnee.id">
          <i class="fal fa-check"></i> Accepter
        </button>
      </ng-container>
      <button class="btn-modal-success" *ngIf="demandeSelectionnee.statut === 'ACCEPTE'"
              (click)="creerCommandeDepuisDevis(demandeSelectionnee)">
        <i class="fal fa-plus-circle"></i> Créer une commande
      </button>
      <button class="btn-modal-cancel" (click)="fermerDetail()">Fermer</button>
    </div>
  </div>
</div>
